module.exports = __webpack_public_path__ + "img/ch60.855c72b6.jpg";